<div id="top"></div>
<wecmp-transversales-header is-fluid="true"></wecmp-transversales-header>
<app-menu></app-menu>
<router-outlet></router-outlet>

<wecmp-transversales-footer></wecmp-transversales-footer>

<app-gotop></app-gotop>
